var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-2"},[_c('TimeComponent',{staticClass:"mt-4"}),_c('FormComponent',{staticClass:"mb-6"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }